import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils/axiosInstance';
import { getToken } from '../../utils/getToken';
import { ApiArrayResponseType } from 'types/api.types';
import { cleanObject } from 'utils/cleanObject';

export interface CategoryQueryParam {
  search?: string;
}
export interface Branch {
  name:        string;
  address:     string;
  state:       string;
  phoneNumber: string;
  code:        string;
  id:          string;
}


export const useGetBranchesQuery = ({ search }: CategoryQueryParam) => {
  const token = getToken();

  return useQuery({
    queryKey: ['getBranches', search],
    queryFn: () =>
      axiosInstance
        .get<ApiArrayResponseType<Branch>>('/branches', { params: cleanObject({search}) })
        .then((res) => res.data),
    enabled: !!token,
  });
};
